import { MarketSetting } from "../../classes";
import moment from 'moment'
const MarketSettingModule = {
  namespaced: true,

  actions: {
    createMarketSetting: async ({ commit, state }, payload) => {
      try {
        let marketSetting = await MarketSetting.createMarketSetting(payload)
        return marketSetting
      } catch (error) {
        throw error
      }
    },
    updateMarketSetting: async ({ commit, state }, payload) => {
      try {
        let marketSetting = await MarketSetting.updateMarketSetting(payload)
        return marketSetting
      } catch (error) {
        throw error
      }
    }
  },
}
export default MarketSettingModule